import { useTranslation } from "react-i18next";
import { TLink } from "../../../types";
import LinkWrapper from "../link-wrapper/link-wrapper";
import styles from "./breadcrumbs-list.module.less";

export type TBreadcrumbsListProps = {
  items: Array<Partial<TLink>>;
};

export const BreadcrumbsList = ({ items }: TBreadcrumbsListProps) => {
  let itemsCopy = [...items];
  // Räkna antal tecken i varje länks title och sätt en gräns för när vi ska endast visa 2 items med ... som prefix
  const characters = items
    .map((items) => items.title?.length || 0)
    .reduce((sum, item) => {
      return sum + item;
    }, 0);

  const SLICE_MODE_LIMIT = 33; // Will need fine tuning

  if (characters > SLICE_MODE_LIMIT) {
    itemsCopy = itemsCopy.slice(-2);
  }

  if (itemsCopy.length < items.length) {
    itemsCopy = [{ title: "..." }, ...itemsCopy];
  }

  const { t } = useTranslation();

  return (
    <nav className={styles.wrapper} aria-label={t("BREADCRUMBS_ARIA_LABEL")}>
      <ul className={`${styles.list} ${styles.mobile}`}>
        {itemsCopy.map((item, i) => {
          const isLastItem = i === itemsCopy.length - 1;

          return (
            <li key={item.title} className={`${isLastItem ? styles.lastItem : ""}`}>
              <LinkWrapper
                className={[item.url ? styles.link : styles.unlinked].join(" ")}
                title={item.title}
                url={item.url ?? undefined}
              />
              {!isLastItem && <span className={styles.separator}>{"/"}</span>}
            </li>
          );
        })}
      </ul>
      <ul className={`${styles.list} ${styles.desktop}`}>
        {items.map((item, i) => {
          const isLastItem = i === items.length - 1;

          return (
            <li key={item.title} className={`${isLastItem ? styles.lastItem : ""}`}>
              <LinkWrapper
                className={[item.url ? styles.link : styles.unlinked].join(" ")}
                title={item.title}
                url={item.url ?? undefined}
              />
              {!isLastItem && <span className={styles.separator}>{"/"}</span>}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
